var DOMAIN = 'https://webupload.lizhi.fm';
var UPLOAD_INNER_URL = '/upload/inner';
var GET_QINIU_TOKEN_URL = '/upload/qiniuToken';
var UPLOAD_QINIU_URL = 'http://upload.qiniup.com/';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

// 是否存在微信对象
var hasWx = (typeof wx === 'undefined' ? 'undefined' : _typeof(wx)) === 'object';
// noop
var noop = function noop() {};

// 序列化参数
function serialize(data) {
  return Object.keys(data).reduce(function (str, k) {
    return '' + str + (str ? '&' : '') + encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
  }, '');
}
// 获取XMLHttpRequest实例，兼容IE
function createXHR() {
  if (window.XMLHttpRequest) {
    return new XMLHttpRequest();
  }
  return new window.ActiveXObject("Microsoft.XMLHTTP");
}

// 将微信接口转换成Promise风格
function promisify(fn) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return new Promise(function (resolve, reject) {
    opt.success = function (res) {
      resolve(res);
    };
    opt.fail = function (err) {
      reject(err);
    };
    fn.call(wx, opt);
  });
}

// 检查返回数据的rCode，如果不为 `0000` 则报错
function checkRcode(data) {
  if (data.rCode !== '0000') {
    throw new Error(data.msg);
  }
}

// 获取文件名
function getFileName(file) {
  var defaultName = Date.now() + '.jpg';
  if (file.name) {
    return file.name;
  } else if (file.path) {
    // 从小程序的filepath中获取filename
    var result = file.path.match(/.+\/\/.+\/(.+)/);
    return result && result[1] || defaultName;
  } else {
    return defaultName;
  }
}

/**
 * http请求封装
 * @param {String} method 请求方法
 * @param {String} url 请求地址
 * @param {Object} header 请求头
 * @param {Function} getXhr 回调http请求实例
 * @param {Object} data 请求数据
 */
function _request(_ref) {
  var _ref$method = _ref.method,
      method = _ref$method === undefined ? 'POST' : _ref$method,
      url = _ref.url,
      header = _ref.header,
      getXhr = _ref.getXhr,
      data = _ref.data;

  return new Promise(function (resolve, reject) {
    var xhr = createXHR();
    xhr.open(method, url);
    if (header) {
      Object.keys(header).forEach(function (k) {
        xhr.setRequestHeader(k, header[k]);
      });
    }
    xhr.onreadystatechange = function () {
      var response = xhr.responseText;
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(JSON.parse(response));
      } else {
        reject({ code: xhr.status, message: response });
      }
    };
    if (typeof getXhr === 'function') {
      getXhr(xhr);
    }
    xhr.send(data);
  });
}
// 调度微信请求或者浏览器的请求方法
function ajax(options) {
  var mpRequest = hasWx && wx.request;
  return mpRequest ? promisify(mpRequest, options).then(function (res) {
    return res.data;
  }) : _request(_extends({}, options, {
    data: serialize(options.data)
  }));
}

// 将对象转换成formdata
function toFormData(data) {
  return Object.keys(data).reduce(function (formData, k) {
    formData.append(k, data[k]);
    return formData;
  }, new FormData());
}

// 上传方法调度
function upload(options) {
  var url = options.url,
      file = options.file,
      data = options.data,
      header = options.header,
      onProgress = options.onProgress;

  if (hasWx && wx.uploadFile) {
    return new Promise(function (resolve, reject) {
      var uploadTask = wx.uploadFile({
        url: url,
        filePath: file.path,
        name: 'file',
        header: header, // 设置请求的 header
        formData: data, // HTTP 请求中其他额外的 form data
        success: function success(res) {
          resolve(JSON.parse(res.data));
        },
        fail: function fail(e) {
          reject(e);
        }
      });
      uploadTask.onProgressUpdate(function (_ref2) {
        var progress = _ref2.progress,
            totalBytesSent = _ref2.totalBytesSent,
            totalBytesExpectedToSend = _ref2.totalBytesExpectedToSend;

        onProgress({
          loaded: totalBytesSent,
          total: totalBytesExpectedToSend,
          progress: progress
        });
      });
    });
  } else {
    return _request({
      url: url,
      header: _extends({}, header),
      getXhr: function getXhr(xhr) {
        xhr.upload.addEventListener('progress', function (e) {
          var lengthComputable = e.lengthComputable,
              loaded = e.loaded,
              total = e.total;

          if (lengthComputable) {
            onProgress({
              loaded: loaded,
              total: total,
              progress: loaded / total * 100
            });
          }
        });
      },
      data: toFormData(_extends({
        file: file
      }, data))
    });
  }
}

var UploadManager = function () {
  /**
   * 
   * @param {Number} bizId 业务号
   * @param {Object} file 文件对象，微信中对应的是 tempFiles 中的对象
   * @param {String} innerToken 上传token
   * @param {Object} putExtra 上传的额外参数
   * @param {String} putExtra.fname 文件名
   * @param {Object} putExtra.params 额外的自定义参数
   * @param {String} domain 公共服务sdk域名 
   * @param {Function} onProgress 上传进度回调
   */
  function UploadManager(_ref) {
    var bizId = _ref.bizId,
        file = _ref.file,
        innerToken = _ref.innerToken,
        _ref$putExtra = _ref.putExtra,
        putExtra = _ref$putExtra === undefined ? {} : _ref$putExtra,
        _ref$domain = _ref.domain,
        domain = _ref$domain === undefined ? DOMAIN : _ref$domain,
        _ref$onProgress = _ref.onProgress,
        onProgress = _ref$onProgress === undefined ? noop : _ref$onProgress;
    classCallCheck(this, UploadManager);

    this.domain = domain;
    this.bizId = bizId;
    this.file = file;
    this.innerToken = innerToken;
    this.onProgress = onProgress;
    this.putExtra = _extends({
      fname: getFileName(this.file)
    }, putExtra);
  }
  // 获取七牛上传的token及其他参数


  createClass(UploadManager, [{
    key: '_getQiniuToken',
    value: function _getQiniuToken() {
      return ajax({
        method: 'POST',
        url: '' + this.domain + GET_QINIU_TOKEN_URL,
        header: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'inner-token': this.innerToken
        },
        data: {
          bizId: this.bizId,
          fileName: this.putExtra.fname,
          fileSize: this.file.size,
          extra: this.putExtra.params ? JSON.stringify(this.putExtra.params) : null
        }
      }).then(function (result) {
        checkRcode(result);
        return result.data;
      });
    }
    // 上传到内部服务器

  }, {
    key: 'toInner',
    value: function toInner() {
      return upload({
        url: '' + this.domain + UPLOAD_INNER_URL,
        file: this.file,
        header: {
          'inner-token': this.innerToken
        },
        data: {
          bizId: this.bizId
        },
        onProgress: this.onProgress.bind(this)
      }).then(function (result) {
        checkRcode(result);
        return result.data;
      });
    }
    // 上传到七牛服务器

  }, {
    key: 'toQiniu',
    value: function toQiniu() {
      var _this = this;

      return this._getQiniuToken().then(function (result) {
        var fileId = result.fileId,
            token = result.token,
            resourceKey = result.resourceKey;

        return upload({
          url: UPLOAD_QINIU_URL,
          file: _this.file,
          data: {
            key: resourceKey,
            token: token,
            'x:fileId': fileId,
            fname: _this.putExtra.fname
          },
          onProgress: _this.onProgress.bind(_this)
        }).then(function (result) {
          return _extends({
            fileId: fileId
          }, result);
        });
      });
    }
  }, {
    key: 'toCustom',
    value: function toCustom(url) {
      var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!url) {
        throw new Error('应该传入 url 参数');
      }
      return upload({
        url: url,
        file: this.file,
        data: _extends({}, extraData),
        onProgress: this.onProgress.bind(this)
      }).then(function (result) {
        if (result.code === 0 || result.rCode === 0) {
          return result.data;
        }

        return Promise.reject(result);
      });
    }
  }]);
  return UploadManager;
}();

export default UploadManager;
//# sourceMappingURL=index.esm.js.map
